import { useState } from "react";
import { Tabs as BaseTabs, cn } from "ui";

interface Tab {
  label: string;
  Panel: () => JSX.Element;
  disabled?: boolean;
}
interface TabsProps {
  tabs: Tab[];
  className?: string;
  onTabClick?: (tab: Tab) => void;
}

export function Tabs({ tabs, className, onTabClick }: TabsProps) {
  const [activeTab, setActiveTab] = useState(tabs[0].label);

  return (
    <BaseTabs
      value={activeTab}
      onValueChange={(value) => {
        onTabClick?.(tabs.find((tab) => tab.label === value)!);
        setActiveTab(value);
      }}
      className={cn("-mx-1 -mb-1", className)}
    >
      <BaseTabs.List className="-mx-4 flex border-b border-b-foundations-subtle">
        {tabs.map((tab) => (
          <BaseTabs.Tab
            key={tab.label}
            value={tab.label}
            disabled={tab.disabled}
            className="flex-1 justify-center border-b-2 border-b-transparent pb-2.5 pl-2 pt-1 text-foundations-subtle focus:border-b-foundations-subtle focus:outline-none enabled:hover:border-b-foundations-subtle disabled:cursor-not-allowed aria-selected:text-foundations-bolder enabled:aria-selected:border-b-info-bold enabled:aria-selected:focus:border-b-info-boldest"
          >
            {tab.label}
          </BaseTabs.Tab>
        ))}
      </BaseTabs.List>

      {tabs.map(({ Panel, label }, idx) => (
        <BaseTabs.Panel
          key={idx}
          value={label}
          className="-mx-1 -mb-1 flex-1 p-4 focus:outline-none focus:ring-2 focus:ring-info-bold"
        >
          <Panel />
        </BaseTabs.Panel>
      ))}
    </BaseTabs>
  );
}
